/**
 *  @class
 *  @function MaxHeight
 */
if (!customElements.get('max-height')) {
  class MaxHeight extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('.max-height--inner-content');
      this.toggle = this.querySelector('.max-height--toggle');
      this.max = Number.parseFloat(this.dataset.max) || 350;
      this.onClick = this.onClick.bind(this);
      this.checkVisible = this.checkVisible.bind(this);
    }

    connectedCallback() {
      if (!this.content || !this.toggle) return;

      this.toggle.addEventListener('click', this.onClick);
      window.addEventListener('resize', this.checkVisible);

      window.requestAnimationFrame(this.checkVisible);
    }

    disconnectedCallback() {
      if (this.toggle) {
        this.toggle.removeEventListener('click', this.onClick);
      }
      window.removeEventListener('resize', this.checkVisible);
    }

    checkVisible() {
      if (this.content.offsetHeight > this.max) {
        this.showToggle();
      } else {
        this.hideToggle();
      }
    }
    showToggle() {
      this.classList.add('max-height--active');
    }
    hideToggle() {
      this.classList.remove('max-height--active');
    }
    onClick() {
      const expanded = this.classList.toggle('max-height--enabled');
      this.toggle.setAttribute('aria-expanded', expanded.toString());
    }
  }
  customElements.define('max-height', MaxHeight);
}
